import { render, staticRenderFns } from "./SMSConsent.vue?vue&type=template&id=235244e4&scoped=true"
import script from "./SMSConsent.vue?vue&type=script&lang=js"
export * from "./SMSConsent.vue?vue&type=script&lang=js"
import style0 from "./SMSConsent.vue?vue&type=style&index=0&id=235244e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235244e4",
  null
  
)

export default component.exports